import i18n from '@/lang';

export const SpecialRules = {
  0: {
    label: i18n.t('basicData.PercentageOfDeclaredAmountMinimumCanBeSet'), // 申报金额比例
    value: 0
  },
  1: {
    label: i18n.t('basicData.OrderAllCostRatioGRIS') + '（GRIS）', // 订单所有费用比例（GRIS）
    value: 1
  },
  2: {
    label: i18n.t('basicData.Issn1'), // ISS税  ISS税（n/（1-税率）*税率）
    value: 2
  },
  7: {
    label: i18n.t('basicData.Issn'),
    value: 7
  },
  3: {
    label: 'ICMS' + i18n.t('basicData.tax'), // ICMS
    value: 3
  },
  5: {
    label: '*BRL/*KG（' + i18n.t('basicData.roundUp') + '）',
    value: 5
  },
  6: {
    label: '*BRL/' + i18n.t('basicData.ticket'),
    value: 6
  },
  4: {
    label: i18n.t('basicData.ExcessWeightSurcharges') + '/' + i18n.t('basicData.ticket'), // 超重额外费用/票
    value: 4
  },
  8: {
    label: i18n.t('basicData.ExcessWeightSurcharges') + '/KG', // 超重额外费用/kg
    value: 8
  },
  9: {
    label: i18n.t('basicData.invoiceAmountRatio'), // 发票金额比例
    value: 9
  },
  10: {
    label: i18n.t('basicData.transportInsuranceRate'), // 运输保险费比例
    value: 10
  },
  11: {
    label: i18n.t('basicData.volumeUnitPricePerCubicMeter'), // 体积*单价/m^3
    value: 11
  }
};

export const businessTypeMap = {
  0: i18n.t('collectionCenter.expressDelivery'),
  1: i18n.t('collectionCenter.lanshou'),
  2: i18n.t('collectionCenter.delivery'),
  3: i18n.t('collectionCenter.expressDelivery') + '、' + i18n.t('collectionCenter.lanshou'),
  4: i18n.t('collectionCenter.expressDelivery') + '、' + i18n.t('collectionCenter.delivery'),
  5: i18n.t('collectionCenter.lanshou') + '、' + i18n.t('collectionCenter.delivery'),
  6: i18n.t('collectionCenter.expressDelivery') + '、' + i18n.t('collectionCenter.lanshou') + '、' + i18n.t('collectionCenter.delivery'),
  8: i18n.t('basicData.wholeVehicle'),
  9: i18n.t('collectionCenter.expressDelivery') + '、' + i18n.t('basicData.wholeVehicle'),
  10: i18n.t('collectionCenter.lanshou') + '、' + i18n.t('basicData.wholeVehicle'),
  11: i18n.t('collectionCenter.delivery') + '、' + i18n.t('basicData.wholeVehicle'),
  12: i18n.t('collectionCenter.expressDelivery') + '、' + i18n.t('collectionCenter.lanshou') + '、' + i18n.t('basicData.wholeVehicle'),
  13: i18n.t('collectionCenter.expressDelivery') + '、' + i18n.t('collectionCenter.delivery') + '、' + i18n.t('basicData.wholeVehicle'),
  14: i18n.t('collectionCenter.lanshou') + '、' + i18n.t('collectionCenter.delivery') + '、' + i18n.t('basicData.wholeVehicle'),
  15: i18n.t('collectionCenter.expressDelivery') + '、' + i18n.t('collectionCenter.lanshou') + '、' + i18n.t('collectionCenter.delivery') + '、' + i18n.t('basicData.wholeVehicle')
};
